(function () {
    'use strict';

    angular
        .module('app.campaign')
        .controller('EditEventsTrackpointModalController', EditEventsTrackpointModal);

    /*
     * This function is injected one parameter from the controller:
     * selectedTrackpoints: an array of selected trackpoints
     * Note: parameters are injected and their modified values will be reflected back in the calling controller
     */
    EditEventsTrackpointModal.$inject = ['$cookies','ModalService', 'EventsService', 'selectedTrackpoints'];
    function EditEventsTrackpointModal($cookies, ModalService, EventsService, selectedTrackpoints) {
        var vm = this;

        var allowedEventTypes = EventsService.getAllowedEventTypes();

        vm.allowedEventTypes = [];
        var checkedEventTypes = {};
        vm.states = ['', 'semi-checked', 'checked'];


        vm.selectedTrackpoints = selectedTrackpoints;
        
        vm.getUrl = function (tp, eventType) {
            return EventsService.getUrl(tp, eventType);
        };

        vm.switchState = function (allowedEventType) {
            switch (allowedEventType.check) {
                case 2:
                    angular.forEach(selectedTrackpoints, function (trackpoint) {
                        trackpoint.eventTypes[allowedEventType.type] = false;
                    });
                    allowedEventType.check = 0;
                    break;
                default:
                    angular.forEach(selectedTrackpoints, function (trackpoint) {
                        trackpoint.eventTypes[allowedEventType.type] = true;
                    });
                    allowedEventType.check = 2;
                    if(allowedEventType.type != 'impression'){
                        vm.openEventWarningModal(allowedEventType)
                    }
                    break;
            }
        };



        /* -------------------------------------
         Event warning modal
         ---------------------------------------*/
        vm.openEventWarningModal = function (allowedEventType) {
            var shouldShow = $cookies.getObject('showSecondEventsWarning');
            if(angular.isUndefined(shouldShow)){
                ModalService
                    .showModal({
                        templateUrl: '../../assets/js/app/campaign/modals/trackpoint/warning/eventtype.html',
                        controller: 'SpecialEventsModalController',
                        controllerAs: 'specialEventsModal',
                        inputs: {
                            url: vm.getUrl(selectedTrackpoints[0],allowedEventType.type),
                            type: allowedEventType.type
                        }
                    })
                    .then(function (modal) {
                        modal.element.modal();
                        modal.close.then(function () {
                            $cookies.putObject('showSecondEventsWarning', false, {
                                path: '/campaign'
                            });
                        });
                    });
            }
        };

        vm.disableWarningForSession = function () {
            vm.showEventsWarning = false;
            $cookies.putObject('showEventsWarning', false, {
                path: '/campaign'
            });
        };

        activate();

        function activate() {

            if (angular.isUndefined($cookies.getObject('showEventsWarning'))) {
                vm.showEventsWarning = true;
                $cookies.putObject('showEventsWarning', true, {
                    path: '/campaign'
                });
            } else {
                vm.showEventsWarning = $cookies.getObject('showEventsWarning');
            }


            angular.forEach(allowedEventTypes, function (allowedEventType) {
                allowedEventType.check = 0;
                vm.allowedEventTypes.push(allowedEventType);
                checkedEventTypes[allowedEventType.type] = 0;
            });

            angular.forEach(selectedTrackpoints, function (trackpoint) {
                angular.forEach(trackpoint.eventTypes, function (isEnabled, eventType) {
                    if (isEnabled == true) {
                        checkedEventTypes[eventType]++;
                    }
                });
            });

            angular.forEach(checkedEventTypes, function (count, eventType) {
                var targetEvent = _.find(vm.allowedEventTypes, function (allowedEventType) {
                    return allowedEventType.type == eventType;
                });

                if (count == selectedTrackpoints.length)
                    targetEvent.check = 2;
                else if (count == 0)
                    targetEvent.check = 0;
                else
                    targetEvent.check = 1;
            });
        }
    }
})();